import { render, staticRenderFns } from "./card-image.vue?vue&type=template&id=2144d87c&scoped=true"
import script from "./card-image.vue?vue&type=script&lang=js"
export * from "./card-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144d87c",
  null
  
)

export default component.exports